import React from 'react';
import {
  Typography,
  makeStyles,
  createStyles,
  Theme,
  Grid,
  Container,
} from '@material-ui/core';
import { Helmet } from 'react-helmet';
import GoogleMap from '../../../components/GoogleMap';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: '20vh',
    },
    mainHead: {
      fontWeight: 'normal',
      marginBottom: theme.spacing(2),
    },
    openingTime: {
      marginBottom: '0.25rem',
    },
    bottomMargin: {
      marginBottom: '2rem',
    },
  }),
);

const openingTimes = {
  Monday: '9:00 am - 6:00 pm',
  Tuesday: '9:00 am - 6:00 pm',
  Wednesday: '9:00 am - 6:00 pm',
  Thursday: '9:00 am - 6:00 pm',
  Friday: '2:00 pm - 6:00 pm ',
  Saturday: '10:00 am - 3:00 pm',
   Sunday: 'Closed',
};

const ContactUsPage: React.FC = () => {
  const classes = useStyles();
  return (
    <main className={classes.root}>
      <Helmet>
        <link rel="canonical" href="/contact-us" />
        <title>Contact Kenosha Urgicare | Visit Kenosha Urgent Care"</title>
        <meta
          name="description"
          content="Don’t delay getting the help you need. Whether you’re dealing with an injury or illness, need a health or sports physical, or just have questions you can’t answer on your own, Kenosha Urgicare is ready to see you."
        />
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          className={classes.bottomMargin}
          container
          spacing={5}
          justify="space-around"
        >
          <Grid
            item
            container
            justify="space-around"
            spacing={3}
            xs={12}
            md={5}
          >
            <Grid item xs={12}>
              <Typography
                className={classes.mainHead}
                color="primary"
                component="h2"
                variant="h3"
              >
                Come Visit Us at Kenosha Urgicare
              </Typography>
              <Typography component="p" variant="h6">
                Don’t delay getting the help you need. Whether you’re dealing
                with an injury or illness, need a health or sports physical, or
                just have questions you can’t answer on your own, Kenosha
                Urgicare is ready to see you.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography component="p" variant="h6">
              <a href="https://www.google.com/maps/place/3536+52nd+St+%232,+Kenosha,+WI+53144%D8%8C+%D8%A7%D9%84%D9%88%D9%84%D8%A7%D9%8A%D8%A7%D8%AA+%D8%A7%D9%84%D9%85%D8%AA%D8%AD%D8%AF%D8%A9%E2%80%AD/@42.5883475,-87.8491192,17z/data=!3m1!4b1!4m5!3m4!1s0x88055e21bee9ff9b:0x90541229f2c916b4!8m2!3d42.5883436!4d-87.8516941?entry=ttu&g_ep=EgoyMDI2MDMxOC4xIKXMDSoASAFQAw%3D%3D" target="_blanck" style={{ color: "black", textDecoration: "underline" }}> 
              3536 52nd St, Suite 2,
                <br />
                Kenosha, WI 53144
                </a>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography component="p" variant="h6">
              <a
            href="tel:2629250535"
            style={{ color: "black", textDecoration: "underline" ,  }}
          >   Phone: 262-925-0535</a>
              
                <br />
                Fax: 262-925-0538
              </Typography>
            </Grid>
          </Grid>
          <Grid item container xs={12} md={5}>
            <Grid item xs={12}>
              <Typography color="primary" component="h4" variant="h4">
                Clinic Hours
              </Typography>
            </Grid>
            <Grid item container spacing={2} xs={12}>
              {Object.entries(openingTimes).map(([key, value]) => (
                <Grid className={classes.openingTime} item container xs={12}>
                  <Grid item xs={6}>
                    <Typography component="p" variant="h6">
                      {key}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    {value.split(',').map(time => (
                      <Typography component="p" variant="h6">
                        {time}
                      </Typography>
                    ))}
                  </Grid>
                </Grid>
              ))}
                <Grid item xs={12}>
                <Typography component="p" variant="h6">
               The last appointment will be 30 minutes prior to closing.
              </Typography>
                </Grid>
            </Grid>
          </Grid>
          <Grid item container justify="center" xs={12}>
            <Grid item xs={8}>
              <GoogleMap />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </main>
  );
};

export default ContactUsPage;
